import React, { useState, useRef, useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  selectFilteredProductions,
  selectProductionFilterVisible,
  selectProductionLoading,
  selectfetchProductionLoading,
} from './store/selectors';
import VirtualList from '../components/VirtualList'; // Import VirtualList
import LoadingSpinner from '../../InitialPage/Sidebar/LoadingSpinner'; // Import LoadingSpinner
import { isHeaderVisible } from 'Core/redux/main/selectors';
import { MODAL_TYPES } from 'Feature/components/app-modals';
import { showModal } from 'Core/redux/main/slice';
import { Edit, Trash2 } from 'react-feather';
import { Button, ButtonGroup } from 'react-bootstrap';
import { deleteProduction, fetchProductionSerialData, getPrinters } from './store/slice';
import { actions as productionActions } from './store/slice';

const { setProduct } = productionActions;

const { PRODUCTION_ADD_EDIT } = MODAL_TYPES;

const ProductionTile = props => {
  const [columnCount, setColumnCount] = useState(6);
  const [columnWidth, setColumnWidth] = useState(300);
  const productionTileRef = useRef(null);
  const filteredProductions = useSelector(selectFilteredProductions);
  const isLoading = useSelector(selectProductionLoading);
  const filterVisible = useSelector(selectProductionFilterVisible);
  const headerVisible = useSelector(isHeaderVisible);
  const isFetchDataLoading = useSelector(selectfetchProductionLoading);

  const updateColumnSettings = useCallback(() => {
    if (productionTileRef.current) {
      const width = productionTileRef.current.offsetWidth;
      let columns = 6;

      if (width < 576) {
        columns = 1; // Mobile
      } else if (width < 768) {
        columns = 3; // Tablets
      } else if (width < 992) {
        columns = 5; // Large screens
      } else {
        columns = 6; // Extra large screens
      }

      setColumnCount(columns);
      setColumnWidth(width / columns);
    }
  }, []);

  useEffect(() => {
    updateColumnSettings();
    window.addEventListener('resize', updateColumnSettings);
    return () => window.removeEventListener('resize', updateColumnSettings);
  }, [updateColumnSettings]);

  const itemData = filteredProductions.map(production => <Tile production={production} />);

  return (
    <div
      className={`shipment-tile-body ${filterVisible ? 'filter-visible' : ''} ${
        !headerVisible ? 'header-collapsed' : ''
      }`}
      ref={productionTileRef}
    >
      {(isLoading || isFetchDataLoading) && <LoadingSpinner />}
      {
        <VirtualList
          columnCount={columnCount}
          rowCount={Math.ceil(filteredProductions.length / columnCount)}
          itemData={itemData}
          columnWidth={columnWidth}
          rowHeight={150} // Adjusted row height
        />
      }
    </div>
  );
};

const Tile = ({ production }) => {
  console.log('Production itemData', production);
  const dispatch = useDispatch();

  const handleEdit = e => {
    e.stopPropagation();
    dispatch(setProduct(production));
    dispatch(getPrinters());
    dispatch(showModal(PRODUCTION_ADD_EDIT, production));
  };

  const handleDelete = e => {
    e.stopPropagation();
    //dispatch(deleteProduction(production.processId));
  };

  return (
    <div key={production.processId || Math.random()} className="shipment-tile">
      <div
        className={`card p-3 m-2 ${production.isNewlyCreated ? 'border-success' : ''}`}
        style={{
          border: '1px solid #ddd',
          borderRadius: '4px',
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        }}
      >
        <div className="tile-actions">
          <ButtonGroup size="sm">
            <Button variant="light" onClick={handleEdit}>
              <Edit size={16} />
            </Button>
            {/* <Button variant="light" onClick={handleDelete}>
              <Trash2 size={16} />
            </Button> */}
          </ButtonGroup>
        </div>
        <div className="d-flex justify-content-between">
          <div className="d-flex flex-row align-items-center">
            <div className="ms-2 c-details">
              <h6 className="mb-0">{production.partNumber} </h6>
              <span className="text-muted fa-sm">Work Ticket: {production.workTicketNumber}</span>
            </div>
          </div>
        </div>
        <div className="ms-2">
          <div className="mt-1">
            <span
              className="badge"
              style={{
                backgroundColor: production.backGroundColor || '#e0e0e0',
                color: production.textColor || '#000000',
              }}
            >
              {production.status || 'N/A'}
            </span>
          </div>
          <div className="mt-3 d-flex align-items-center" style={{ lineHeight: '1rem' }}>
            <h5 className="heading me-2">QTY: {production.quantity}</h5> |{' '}
            <h5 className="ms-2 heading">Cell: {production.cellNumber}</h5>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductionTile;
